export const slotGamesSoftwareFeaturesTextContent = {
  headingText: "Online Slot Game Software Features",
  imageSrc: "/assets/stock-img/slot_game_software_features_img.webp",
  content: [
    {
      iconSrc: "/assets/stock-img/slot_game_software_features_img_01.webp",
      titleText: "Custom Art & Animation",
      paraText: "Superb bespoke art, animation, and slot effects configured to your slot game platform for strong engagement.",
    },
    {
      iconSrc: "/assets/stock-img/slot_game_software_features_img_02.webp",
      titleText: "Multi Currency Gaming",
      paraText: "From international currencies to cryptos, DeFis, custom tokens, NFTs, and more; offer flexible currency options for smooth gameplay.",
    },
    {
      iconSrc: "/assets/stock-img/slot_game_software_features_img_03.webp",
      titleText: "Video & Sound Effects",
      paraText: "Thrilling video animations, sound effects, and music that keep users entertained during the whole gameplay.",
    },
    {
      iconSrc: "/assets/stock-img/slot_game_software_features_img_04.webp",
      titleText: "Gamification",
      paraText: "Independently and flexibly maintain your slot lobby, manage leaderboards, challenges and quests, and other personalized game management.",
    },
    {
      iconSrc: "/assets/stock-img/slot_game_software_features_img_05.webp",
      titleText: "Random Number Generator (RNG)",
      paraText: "RNG tools like Fortuna, Mersenne Twister, etc., or customized for full fairness and transparency in gaming.",
    },
    {
      iconSrc: "/assets/stock-img/slot_game_software_features_img_06.webp",
      titleText: "Bonus Engine",
      paraText: "Progressive jackpots, achievement badges, free spins, daily/weekly goals, boosters, referrals, etc. for superb player acquisition.",
    },
    {
      iconSrc: "/assets/stock-img/slot_game_software_features_img_07.webp",
      titleText: "Live Analytics & Reporting",
      paraText: "Superb live slot gaming with analytics, data reporting, and statistical progress for easy records management.",
    },
    {
      iconSrc: "/assets/stock-img/slot_game_software_features_img_08.webp",
      titleText: "Localization",
      paraText: "Access slot game software in various languages, offer thematic slots, and diverse currencies using geographical preferences and trends.",
    },
    {
      iconSrc: "/assets/stock-img/slot_game_software_features_img_09.webp",
      titleText: "CRM",
      paraText: "Seamless filtration, segmentation, and management of users based on their preferences, history, location, and more.",
    },
    {
      iconSrc: "/assets/stock-img/slot_game_software_features_img_10.webp",
      titleText: "Risks Management",
      paraText: "From land-based to online and cloud-ready PAM iGaming, one sport coverage to multi site, and much more for a fully versatile platform.",
    },
    {
      iconSrc: "/assets/stock-img/slot_game_software_features_img_11.webp",
      titleText: "Reel Types",
      paraText: "Tumbling reels, cascading reels, rotating reels, and various other reel types are supported to elevate your slot adventure.",
    },
    {
      iconSrc: "/assets/stock-img/slot_game_software_features_img_12.webp",
      titleText: "Wild Types",
      paraText: "Standard wilds, expanding wilds, stacked wilds, sticky wilds, multiplier wilds, and more for superb winning combinations.",
    },
  ],
};
